import { RootState } from "@store";
import { useSelector } from "react-redux";

export const useTimers = (id: number) => {
  const timers = useSelector((state: RootState) => state.timer.timers);

  if (id === 0) return timers;

  return timers[id];
};
